/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import tableEditPersonLabel from '../../../../components/personLabel/tableEditPersonLabel.vue';

export default {
  selection: {
    type: 'selection',
    prop: 'index',
    selectable: row => !(row.superviseStatus === 3 || row.zbBlackStatus === 2),
    reserve: true
  },
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    label: '项目参与人',
    prop: 'NAME'
  },
  phone: {
    label: '手机号',
    prop: 'phone'
  },
  enterpriseName: {
    label: '个体名称',
    prop: 'enterpriseName'
  },
  otherPersonLabel: {
    label: '其他项目标签',
    prop: 'userTag',
    formatter: (row, c, v) => v || '未设置'
  },
  importPersonLabel: {
    label: '本次导入标签',
    prop: 'importPersonLabel',
    render: (h, ctx, row) => {
      return h(tableEditPersonLabel, {
        props: {
          personLabels: ctx.parent.$parent.personLabels, // 对象传递，耦合性有点高，暂时没想到别的办法
          tableRowData: row
        }
      });
    }
  }
};
